import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';
import { postApi,baseURL } from '../components/Utility'
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from 'mobx';
import { act } from 'react-dom/test-utils';
import config from '../config';
import JourneyMonitoringReport from '../components/JourneyMonitoringReport';
import { message } from "antd";


class JourneyMonitoringReportStore {
  loading=false
  JourneymonitorReport = []
  getDrivers=[]
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      JourneymonitorReport: observable,
      loadData: action,

    });
    this.rootStore = rootStore;

  }



  async loadData({ companyId,vehicleId,offset, limit,driverId,fromDate,toDate,pageNo,journeyNum }) {
    this.loading=true
    // console.log("vehicle list")
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "driverId": driverId, "fromDate": fromDate, "toDate": toDate, "offset": offset,"limit":limit, "page":pageNo, "journeyNum": journeyNum }

    const base64Input = await base64_encode(JSON.stringify(postData));
    if(config.pythonReport==1){
       var response = await postApi
        .getClient("report")
        .post("/miscellaneous_report/JourneyMonitorReport", postData);
    }
    
    // var response = await postApi.getClient().post("index.php?c=vehicle&a=fuelrefill", "postData=" + base64Input);
    
    this.JourneymonitorReport = response?.data?.data?.journeyReport
    this.total = response?.data?.data?.TotalCount
    this.loading=false
  }

  async getDriversByCompanyId({companyId}){
    var postData = {companyId:companyId}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=driver&a=getdatabycompany", "postData=" + base64Input);
    console.log(response, "post")
    this.getDrivers =response?.data?.data
    return response?.data?.data
  }

  

  async exportExcel(getData) {
     if (config.pythonReport === 1) {
      try {
          var response=await postApi.getClient("report").post("/miscellaneous_report/JourneyMonitorReport/download/excel", getData, {
          responseType: "blob",
        });
        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Journey Monitoring Report.xlsx";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
    } catch (error) {
        message.error("Failed to download the report. Please try again.")
    }
              
    //     this.pythonReportMessage = true;
    //   } catch (error) {
    //     this.pythonReportErrorMessage = true;
    //   }
    }
  }


  async exportpdf(getData) {
    let lang = "english";
    if (config.pythonReport === 1) {
      try {
          var response = await postApi.getClient("report").post("/miscellaneous_report/JourneyMonitorReport/download/pdf", getData, {
          responseType: "blob",
        });
            const blob = new Blob([response.data], {
                type: 'application/pdf'
            });
        
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Journey Monitoring Report.pdf";
        
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
    } catch (error) {
        message.error("Failed to download the report. Please try again.")
    }
    //     this.pythonReportMessage = true;
    //   } catch (error) {
    //     this.pythonReportErrorMessage = true;
    //   }
    
  }
  }

  // async exportcsv(getData) {
  //   let lang = "english";
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=vehicle&a=exportfuelrepcsv&cid=" +
  //     getData.companyId +
  //     "&userId=" +
  //     getData.userId +
  //     "&vid=" +
  //     getData.vehicleId +
  //     "&did="+
  //     getData.DriverId+
  //     "&fD=" +
  //     getData.fromDate +
     
  //     "&tD=" +
  //     getData.toDate +
  //     "&colList=" +
  //     getData.colList +
  //     "&language=" +
  //     lang;
  // }
  // async exportxml(getData) {
  //   let lang = "english";
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=vehicle&a=exportfuelrepxml&cid=" +
  //     getData.companyId +
  //     "&userId=" +
  //     getData.userId +
  //     "&vid=" +
  //     getData.vehicleId +
  //     "&did="+
  //     getData.DriverId+
  //     "&fD=" +
  //     getData.fromDate +
     
  //     "&tD=" +
  //     getData.toDate +
  //     "&colList=" +
  //     getData.colList +
  //     "&language=" +
  //     lang;
  // }
}

export default JourneyMonitoringReportStore;
